import { render, staticRenderFns } from "./add-dates-available-popup.vue?vue&type=template&id=488c4a6b"
import script from "./add-dates-available-popup.vue?vue&type=script&lang=js"
export * from "./add-dates-available-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports